module.exports = __webpack_public_path__ + "static/media/6.3ceb84f2.png";